import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import KauflandCredentialsSubTab from "./Kaufland/KauflandCredentials";
import KauflandArticlesSubTab from "./Kaufland/KauflandArticles";
import KauflandPriceSetterSubTab from "./Kaufland/KauflandConfiguration";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const KauflandTab = ({
  initialSku = null,
  onNavConsumed,
  onNavigateToBase,
}) => {
  const [kauflandSubTab, setKauflandSubTab] = useState(1);

  React.useEffect(() => {
    if (initialSku) {
      setKauflandSubTab(1);
    }
  }, [initialSku]);

  const handleKauflandSubTabChange = (event, newValue) => {
    setKauflandSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={kauflandSubTab}
              onChange={handleKauflandSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Credentials" />
              <Tab label="Articles" />
              <Tab label="Configuration" />
            </Tabs>
          </Box>

          {/* Kaufland Credentials Tab */}
          <TabPanel value={kauflandSubTab} index={0}>
            <KauflandCredentialsSubTab />
          </TabPanel>
          {/* Articles Tab */}
          <TabPanel value={kauflandSubTab} index={1}>
            <KauflandArticlesSubTab
              initialSku={initialSku}
              onSkuConsumed={onNavConsumed}
              onNavigateToBase={onNavigateToBase}
            />
          </TabPanel>

          {/* Configuration Tab */}
          <TabPanel value={kauflandSubTab} index={2}>
            <KauflandPriceSetterSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default KauflandTab;
